import React from 'react';
import BirthdaySection from './BirthdaySection';
import FirstVisitSection from './FirstVisitSection';
import NPSFeedbackSection from './NPSFeedbackSection';
import GoogleReviewSection from './GoogleReviewSection';
import styles from './Relationship.module.css';

/**
 * "Relacionamento": gestos que fidelizam o paciente. As seções com itens
 * aparecem primeiro; as vazias viram pílulas na linha "Em dia".
 */
function RelationshipPanel({ birthdays, firstVisits, npsFeedback, googleReviews }) {
  const sections = [
    { key: 'birthday', count: birthdays.length, render: () => <BirthdaySection list={birthdays} /> },
    { key: 'firstVisit', count: firstVisits.length, render: () => <FirstVisitSection list={firstVisits} /> },
    { key: 'nps', count: npsFeedback.length, render: () => <NPSFeedbackSection list={npsFeedback} /> },
    { key: 'google', count: googleReviews.length, render: () => <GoogleReviewSection list={googleReviews} /> },
  ];
  const filled = sections.filter((s) => s.count > 0);
  const empty = sections.filter((s) => s.count === 0);

  return (
    <section className={styles.card} aria-label="Relacionamento">
      <header className={styles.header}>
        <h2 className={styles.title}>Relacionamento</h2>
        <p className={styles.subtitle}>Pequenos gestos que fazem o paciente voltar</p>
      </header>

      {filled.length > 0 ? (
        <div className={styles.sections}>
          {filled.map(({ key, render }) => <React.Fragment key={key}>{render()}</React.Fragment>)}
        </div>
      ) : (
        <p className={styles.allDone}>Nenhum contato de relacionamento para hoje.</p>
      )}

      {empty.length > 0 && (
        <div className={styles.doneRow}>
          <span className={styles.doneLabel}>Em dia</span>
          <div className={styles.chips}>
            {empty.map(({ key, render }) => <React.Fragment key={key}>{render()}</React.Fragment>)}
          </div>
        </div>
      )}
    </section>
  );
}

export default RelationshipPanel;
